var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader-container"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":64}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }